export const getPercentageClass = (
  percentage: number,
  baseClass = 'font-s-14px font-weight-bold'
) => {
  if (percentage > 0) {
    return `${baseClass} text-negative`;
  }
  if (percentage < 0) {
    return `${baseClass} text-positive`;
  }

  return `${baseClass} text-neutral-40`;
};
